import type { Preferences } from "../persistence/GameSave";

const SFX: Readonly<Record<string, string>> = {
  take: "/sfx/freesound_community-take-it-90781.mp3",
  "door-open": "/sfx/freesound_community-dooropen2cs-108190.mp3",
};

export class SfxManager {
  private pool: HTMLAudioElement[] = [];
  private preferences: Preferences;

  constructor(preferences: Preferences) {
    this.preferences = preferences;
  }

  update(preferences: Preferences): void {
    this.preferences = preferences;
  }

  play(key: string): void {
    const src = SFX[key];
    if (!src || this.preferences.muted) return;
    const audio = this.pooled();
    audio.src = src;
    audio.volume = this.preferences.soundVolume;
    void audio.play().catch(() => {});
  }

  private pooled(): HTMLAudioElement {
    for (const a of this.pool) {
      if (a.paused) return a;
    }
    const a = new Audio();
    this.pool.push(a);
    return a;
  }
}
